import { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { apiRequest } from '@tpct/admin-ui';

type ModuleSyncButtonProps = {
  companyId: number;
  providerSlug: string;
  bootstrapKey: string;
};

const ModuleSyncButton = ({ companyId, providerSlug, bootstrapKey }: ModuleSyncButtonProps) => {
  const queryClient = useQueryClient();
  const [isSyncing, setIsSyncing] = useState(false);

  const handleSync = async () => {
    setIsSyncing(true);
    try {
      await apiRequest(
        `company/${companyId}/modules/${providerSlug}/sync`,
        { method: 'POST' },
        bootstrapKey
      );
      await queryClient.invalidateQueries({ queryKey: ['company', companyId] });
    } finally {
      setIsSyncing(false);
    }
  };

  return (
    <button
      type="button"
      className="module-sync-btn"
      onClick={() => void handleSync()}
      disabled={isSyncing}
      aria-label={`Synchroniser ${providerSlug}`}
    >
      {isSyncing ? (
        <span className="module-sync-btn__spinner" aria-hidden="true" />
      ) : null}
      Synchroniser
    </button>
  );
};

export default ModuleSyncButton;
